import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Spinner, Table, Modal, Form, InputGroup, Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faEdit, faSearch, faBox, faStamp, faDollarSign, faCreditCard, faCheckCircle, faTrashAlt, faBuilding } from '@fortawesome/free-solid-svg-icons';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';
import SoftBadge from 'components/common/SoftBadge';
import ModalAsociarPlanFacturacion from './ModalAsociarPlanFacturacion';
import ModalHistorialPlanFacturacionMx from './ModalHistorialPlanFacturacionMx';

const PlanesFacturacionMx = ({ idCliente, onPlanAgregado }) => {
    const { token, setToken, idCatTipoUsuario, idUsuario } = useToken();
    const puedeAsignarTimbresIniciales = Number(idCatTipoUsuario) === 1 || Number(idCatTipoUsuario) === 8;
    const esPlanActivo = (plan) => plan.bIsActive === true || plan.bIsActive === 1;
    const esPlanNuevoSinTimbres = (plan) =>
        (plan.iCantidades ?? 0) === 0 && plan.bTuvoTimbres !== true && plan.bTuvoTimbres !== 1;

    const { showErrorToast, showSuccessToast } = useToast();
    const [cargando, setCargando] = useState(false);
    const [planes, setPlanes] = useState([]);
    const [showModalAgregarTimbres, setShowModalAgregarTimbres] = useState(false);
    const [showModalAgregarPlan, setShowModalAgregarPlan] = useState(false);
    const [planesDisponibles, setPlanesDisponibles] = useState([]);
    const [busquedaPlan, setBusquedaPlan] = useState('');
    const [cargandoPlanesDisponibles, setCargandoPlanesDisponibles] = useState(false);
    const [creandoOrden, setCreandoOrden] = useState(false);
    const [rfcNuevoPlan, setRfcNuevoPlan] = useState('');
    const [guardandoPlan, setGuardandoPlan] = useState(false);
    const [idPlanFacturaMx, setIdPlanFacturaMx] = useState('');
    const [modoEdicion, setModoEdicion] = useState(false);
    const [planSeleccionado, setPlanSeleccionado] = useState(null);
    const [formaPagoSeleccionada, setFormaPagoSeleccionada] = useState(null);

    const [planAsociado, setPlanAsociado] = useState(null);
    const [ordenesSinPlan, setOrdenesSinPlan] = useState([]);
    const [cargandoOrdenesSinPlan, setCargandoOrdenesSinPlan] = useState(false);
    const [tabActivo, setTabActivo] = useState('planes');

    const [showModalAsociarPlan, setShowModalAsociarPlan] = useState(false);
    const [ordenSeleccionada, setOrdenSeleccionada] = useState(null);
    const [showModalDesactivar, setShowModalDesactivar] = useState(false);
    const [showModalTimbresIniciales, setShowModalTimbresIniciales] = useState(false);
    const [planTimbresIniciales, setPlanTimbresIniciales] = useState(null);
    const [cantidadTimbresIniciales, setCantidadTimbresIniciales] = useState('');
    const [guardandoTimbresIniciales, setGuardandoTimbresIniciales] = useState(false);
    const [planADesactivar, setPlanADesactivar] = useState(null);
    const [desactivando, setDesactivando] = useState(false);
    const [showModalHistorial, setShowModalHistorial] = useState(false);
    const [planHistorialSeleccionado, setPlanHistorialSeleccionado] = useState(null);

    useEffect(() => {
        obtenerPlanesFacturacion();
        obtenerOrdenesSinPlan();
    }, []);

    const obtenerPlanesFacturacion = async () => {
        setCargando(true);
        setPlanes([]);

        try {
            const response = await fetch('/api/cliente/getPlanesFacturacion', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ idClienteAkasia: idCliente })
            });

            if (response.ok) {
                const data = await response.json();


                if (data?.iResponseType === 1 && data?.detalles) {
                    const detalles = JSON.parse(data.detalles);
                    const table = detalles?.table2 || detalles?.Table2 || [];
                    setPlanes(Array.isArray(table) ? table : []);
                } else {
                    setPlanes(Array.isArray(data) ? data : data?.table1 || []);
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Hubo un problema al obtener planes de facturación: ' + error.message);
        } finally {
            setCargando(false);
        }
    };

    const handleAbrirModalAgregarPlan = () => {
        setShowModalAgregarPlan(true);
        setRfcNuevoPlan('');
        setIdPlanFacturaMx('');
        setModoEdicion(false);
    };

    const handleAbrirModalAgregarTimbres = async (plan) => {
        setShowModalAgregarTimbres(true);
        setPlanAsociado(plan);
        await obtenerPlanesDisponibles();
    };

    const handleEditarPlan = (plan) => {
        setShowModalAgregarPlan(true);
        setRfcNuevoPlan(plan.vRfc || '');
        setIdPlanFacturaMx(plan.idPlanFacturaMx || '');
        setModoEdicion(true);
    };

    const handleAbrirModalTimbresIniciales = (plan) => {
        setPlanTimbresIniciales(plan);
        setCantidadTimbresIniciales('');
        setShowModalTimbresIniciales(true);
    };

    const handleCerrarModalTimbresIniciales = () => {
        setShowModalTimbresIniciales(false);
        setPlanTimbresIniciales(null);
        setCantidadTimbresIniciales('');
    };

    const handleGuardarTimbresIniciales = async () => {
        const cantidad = parseInt(cantidadTimbresIniciales, 10);
        if (!planTimbresIniciales?.idPlanFacturaMx || !cantidad || cantidad <= 0) {
            showErrorToast('Ingrese una cantidad de timbres válida');
            return;
        }

        setGuardandoTimbresIniciales(true);
        try {
            const response = await fetch('/api/cliente/UpdateTimbresInicialesPlanFacturacionMx', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    idPlanFacturaMx: planTimbresIniciales.idPlanFacturaMx,
                    iCantidadTimbres: cantidad,
                    idCatTipoUsuario: Number(idCatTipoUsuario)
                })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    showSuccessToast('Timbres iniciales asignados correctamente');
                    handleCerrarModalTimbresIniciales();
                    obtenerPlanesFacturacion();
                    if (onPlanAgregado) onPlanAgregado();
                } else {
                    showErrorToast(data.vMessage || data.vResponseCode || 'Error al asignar timbres iniciales');
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                const errorData = await response.json().catch(() => ({}));
                showErrorToast(errorData.vMessage || `Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Error al asignar timbres iniciales: ' + error.message);
        } finally {
            setGuardandoTimbresIniciales(false);
        }
    };

    const handleAbrirModalHistorial = (plan) => {
        setPlanHistorialSeleccionado(plan);
        setShowModalHistorial(true);
    };

    const handleCerrarModalHistorial = () => {
        setShowModalHistorial(false);
        setPlanHistorialSeleccionado(null);
    };

    const handleCerrarModalAgregarPlan = () => {
        setShowModalAgregarPlan(false);
        setRfcNuevoPlan('');
        setIdPlanFacturaMx('');
        setModoEdicion(false);
    };

    const handleCerrarModalAgregarTimbres = () => {
        setShowModalAgregarTimbres(false);
        setBusquedaPlan('');
        setPlanSeleccionado(null);
        setFormaPagoSeleccionada(null);
        setPlanAsociado(null);
    };

    const handleGuardarNuevoPlan = async () => {
        if (!rfcNuevoPlan.trim()) {
            showErrorToast('Por favor ingrese un RFC válido');
            return;
        }

        setGuardandoPlan(true);
        try {
            const response = await fetch('/api/cliente/WSFacturacionMXAuthInsertUpdate', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    idClienteAkasia: idCliente,
                    rfc: rfcNuevoPlan.trim(),
                    idPlanFacturaMx: idPlanFacturaMx || null,
                    bIsActive: true
                })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    showSuccessToast(data.vMessage || (modoEdicion ? 'Plan actualizado exitosamente' : 'Plan de facturación agregado exitosamente'));
                    handleCerrarModalAgregarPlan();
                    obtenerPlanesFacturacion();
                    if (onPlanAgregado) onPlanAgregado();
                } else {
                    showErrorToast(data.vMessage || 'Error al guardar el plan');
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                const errorData = await response.json().catch(() => ({}));
                showErrorToast(errorData.vMessage || `Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Error al guardar el plan: ' + error.message);
        } finally {
            setGuardandoPlan(false);
        }
    };

    const obtenerPlanesDisponibles = async () => {
        setCargandoPlanesDisponibles(true);
        try {
            const response = await fetch('/api/cliente/getPlanesDisponiblesFacturacionMx', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({})
            });

            if (response.ok) {
                const data = await response.json();
                console.log('Respuesta completa de getPlanesDisponiblesFacturacionMx:', data);

                if (data?.iResponseType === 1 && data?.detalles) {
                    const detalles = JSON.parse(data.detalles);
                    console.log('Detalles parseados:', detalles);
                    const table = detalles?.table2 || detalles?.Table2 || [];
                    console.log('Table2 extraída:', table);
                    setPlanesDisponibles(Array.isArray(table) ? table : []);
                } else {
                    console.log('Usando data directamente o data.table2');
                    setPlanesDisponibles(Array.isArray(data) ? data : data?.table2 || []);
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Error al obtener planes disponibles: ' + error.message);
        } finally {
            setCargandoPlanesDisponibles(false);
        }
    };

    console.log('Planes disponibles para agregar timbres:', planesDisponibles);

    const obtenerOrdenesSinPlan = async () => {
        setCargandoOrdenesSinPlan(true);
        setOrdenesSinPlan([]);

        try {
            const response = await fetch(`/api/orden/GetOrdenSinPlanFactura?idClienteAkasia=${idCliente}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });

            if (response.ok) {
                const data = await response.json();
                console.log('Respuesta de GetOrdenSinPlanFactura:', data);

                if (data?.iResponseType === 1 && data?.detalles) {
                    const detalles = JSON.parse(data.detalles);
                    const table = detalles?.table2 || detalles?.Table2 || [];
                    setOrdenesSinPlan(Array.isArray(table) ? table : []);
                } else {
                    setOrdenesSinPlan(Array.isArray(data) ? data : data?.table2 || []);
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Error al obtener órdenes sin plan: ' + error.message);
        } finally {
            setCargandoOrdenesSinPlan(false);
        }
    };

    const obtenerFormasPago = async () => {
        try {
            const response = await fetch('/api/cliente/getFormasPago', {
                method: 'GET',
                headers: { 'Authorization': 'Bearer ' + token }
            });
            if (response.ok) {
                const data = await response.json();
                let lista = [];
                if (data?.iResponseType === 1 && data?.detalles) {
                    const detalles = JSON.parse(data.detalles);
                    lista = detalles?.table2 || detalles?.Table2 || [];
                } else {
                    lista = Array.isArray(data) ? data : data?.table2 || [];
                }
                const forma = lista.find(f => f.vClave === '99') || null;
                setFormaPagoSeleccionada(forma);
            } else if (response.status === 401) {
                setToken(null);
                location.href = '';
            }
        } catch { /* silencioso */ }
    };

    const handleSeleccionarPlan = async (plan) => {
        setPlanSeleccionado(plan);
        await obtenerFormasPago();
    };

    const handleVolverALista = () => {
        setPlanSeleccionado(null);
        setFormaPagoSeleccionada(null);
    };

    const handleConfirmarOrden = async () => {
        setCreandoOrden(true);
        try {
            const idPlanTarget = planAsociado?.idPlanFacturaMx || planAsociado?.idPlanFacturacionMx || planAsociado?.idPlanFacturaMX;

            const body = {
                idClienteAkasia: idCliente,
                idUsuario: idUsuario,
                vUUIDProducto: planSeleccionado.vUUIDProducto,
                idCatFormaPago: formaPagoSeleccionada?.idCatFormaPago ?? 99
            };

            // Solo agregar idPlanFacturaMx si la orden viene desde un plan de facturación
            if (idPlanTarget) {
                body.idPlanFacturaMx = Number(idPlanTarget);
                body.idPlanFacturacionMx = Number(idPlanTarget);
            }

            const response = await fetch('/api/orden/generarOrdenFacturacionMx', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    showSuccessToast('Orden creada exitosamente');
                    handleCerrarModalAgregarTimbres();
                    obtenerPlanesFacturacion();
                    if (onPlanAgregado) onPlanAgregado();
                    try {
                        const detalles = typeof data.detalles === 'string' ? JSON.parse(data.detalles) : data.detalles;
                        const idOrden = Array.isArray(detalles) ? detalles[0]?.idOrden : detalles?.idOrden;
                        if (idOrden) {
                            window.location.href = `/ordenes/detalle/${idOrden}`;
                        }
                    } catch { /* sin id de orden */ }
                } else {
                    showErrorToast(data.vMessage || 'Error al crear la orden');
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                const errorData = await response.json().catch(() => ({}));
                showErrorToast(errorData.vMessage || `Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Error al crear la orden: ' + error.message);
        } finally {
            setCreandoOrden(false);
        }
    };

    const handleAbrirModalAsociarPlan = (orden) => {
        setOrdenSeleccionada(orden);
        setShowModalAsociarPlan(true);
    };

    const handleCerrarModalAsociarPlan = () => {
        setShowModalAsociarPlan(false);
        setOrdenSeleccionada(null);
    };

    const handlePlanAsociado = async () => {
        await obtenerOrdenesSinPlan();
        await obtenerPlanesFacturacion();
    };

    const handleAbrirModalDesactivar = (plan) => {
        setPlanADesactivar(plan);
        setShowModalDesactivar(true);
    };

    const handleCerrarModalDesactivar = () => {
        setShowModalDesactivar(false);
        setPlanADesactivar(null);
    };

    const handleConfirmarDesactivar = async () => {
        setDesactivando(true);
        try {
            const response = await fetch('/api/cliente/WSFacturacionMXAuthDesactivarRfc', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ idPlanFacturaMx: planADesactivar.idPlanFacturaMx })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                        showSuccessToast(data.vMessage || data.vResponseDescription || 'RFC desactivado exitosamente');
                    handleCerrarModalDesactivar();
                    obtenerPlanesFacturacion();
                    if (onPlanAgregado) onPlanAgregado();
                } else {
                        showErrorToast(data.vMessage || data.vErrorDescription || 'Error al desactivar el plan');
                }
            } else {
                if (response.status === 401) { setToken(null); location.href = ''; }
                const errorData = await response.json().catch(() => ({}));
                showErrorToast(errorData.vMessage || `Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Error al desactivar el plan: ' + error.message);
        } finally {
            setDesactivando(false);
        }
    };

    const handleReactivarPlan = async (plan) => {
        setDesactivando(true);
        try {
            const response = await fetch('/api/cliente/WSFacturacionMXAuthInsertUpdate', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    idClienteAkasia: idCliente,
                    rfc: plan.vRfc,
                    idPlanFacturaMx: plan.idPlanFacturaMx,
                    bIsActive: true
                })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    showSuccessToast(data.vMessage || 'RFC reactivado exitosamente');
                    obtenerPlanesFacturacion();
                    if (onPlanAgregado) onPlanAgregado();
                } else {
                    showErrorToast(data.vMessage || 'Error al reactivar el RFC');
                }
            } else {
                if (response.status === 401) { setToken(null); location.href = ''; }
                const errorData = await response.json().catch(() => ({}));
                showErrorToast(errorData.vMessage || `Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Error al reactivar el RFC: ' + error.message);
        } finally {
            setDesactivando(false);
        }
    };

    const planesFiltrados = planesDisponibles.filter(plan =>
        plan.vNombreProducto?.toLowerCase().includes(busquedaPlan.toLowerCase()) ||
        plan.iCantidadTimbresMx?.toString().includes(busquedaPlan)
    );

    const renderOrdenesSinPlan = () => {
        if (cargandoOrdenesSinPlan) {
            return (
                <div className="d-flex align-items-center">
                    <Spinner animation="border" size="sm" className="me-2" />
                    Cargando órdenes...
                </div>
            );
        }

        if (ordenesSinPlan.length === 0) {
            return (
                <p className="mb-0 text-muted">
                    No hay órdenes pagadas sin plan asociado.
                </p>
            );
        }

        return (
            <div className="d-flex flex-column gap-2 py-1">
                {ordenesSinPlan.map((orden, index) => (
                    <div
                        key={orden.idOrden || index}
                        className="border rounded-3 px-3 py-2 bg-white shadow-sm d-flex align-items-center gap-3"
                    >
                        {/* ID Orden */}
                        <div className="flex-shrink-0">
                            <div className="text-muted" style={{ fontSize: '0.7rem' }}>Orden</div>
                            <span
                                className="fw-bold text-primary"
                                style={{ cursor: 'pointer', fontSize: '0.9rem' }}
                                onClick={() => window.open(`/ordenes/detalle/${orden.idOrden}`, '_blank')}
                            >
                                #{orden.idOrden}
                            </span>
                        </div>

                        {/* RFC */}
                        <div className="flex-fill" style={{ minWidth: 0 }}>
                            <div className="text-muted" style={{ fontSize: '0.7rem' }}>RFC</div>
                            {orden.vRfc ? (
                                <div className="fw-semibold text-truncate" style={{ fontSize: '0.85rem' }}>{orden.vRfc}</div>
                            ) : (
                                <span className="badge bg-warning text-dark" style={{ fontSize: '0.7rem' }}>Sin asociar</span>
                            )}
                        </div>

                        {/* Timbres */}
                        <div className="flex-shrink-0 text-center">
                            <div className="text-muted" style={{ fontSize: '0.7rem' }}>Timbres</div>
                            <span className="fw-bold text-info" style={{ fontSize: '0.9rem' }}>{orden.iCantidadTimbres ?? '—'}</span>
                        </div>

                        {/* Total */}
                        <div className="flex-shrink-0 text-center">
                            <div className="text-muted" style={{ fontSize: '0.7rem' }}>Total</div>
                            <span className="fw-bold text-success" style={{ fontSize: '0.9rem' }}>${orden.dTotal ?? '—'}</span>
                        </div>

                        {/* Estado */}
                        <div className="flex-shrink-0 text-center">
                            <span className={`badge ${orden.bIsPaid ? 'bg-success' : 'bg-warning text-dark'}`} style={{ fontSize: '0.7rem' }}>
                                {orden.bIsPaid ? 'Pagada' : 'Pendiente'}
                            </span>
                        </div>

                        {/* Acción */}
                        <div className="flex-shrink-0">
                            {orden.vRfc ? (
                                <Button
                                    variant="outline-info"
                                    size="sm"
                                    onClick={() => window.open(`/ordenes/detalle/${orden.idOrden}`, '_blank')}
                                    style={{ fontSize: '0.72rem', whiteSpace: 'nowrap' }}
                                >
                                    Ver Detalles
                                </Button>
                            ) : (
                                <Button
                                    variant="primary"
                                    size="sm"
                                    onClick={() => handleAbrirModalAsociarPlan(orden)}
                                    style={{ fontSize: '0.72rem', whiteSpace: 'nowrap' }}
                                >
                                    <FontAwesomeIcon icon={faPlusCircle} className="me-1" />
                                    Asociar Plan
                                </Button>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    const renderContent = () => {
        if (cargando) {
            return (
                <div className="d-flex align-items-center">
                    <Spinner animation="border" size="sm" className="me-2" />
                    Cargando planes...
                </div>
            );
        }

        if (planes.length === 0) {
            return <p className="mb-0 text-muted">No se encontraron planes.</p>;
        }

        return (
            <div className="d-flex flex-column gap-3">
                {planes.map((plan) => (
                    (() => {
                        const planActivo = plan.bIsActive === true || plan.bIsActive === 1;
                        return (
                    <div
                        key={plan.idPlanFacturaMx}
                        className="border rounded"
                        style={{ overflow: 'hidden' }}
                    >
                        {/* Encabezado del plan */}
                        <div className="d-flex align-items-center justify-content-between px-3 py-2">
                            <div className="d-flex align-items-center gap-2">
                                <div
                                    className="rounded d-flex align-items-center justify-content-center bg-primary bg-opacity-10"
                                    style={{ width: '32px', height: '32px', flexShrink: 0 }}
                                >
                                    <FontAwesomeIcon icon={faBuilding} className="text-primary" />
                                </div>
                                <div>
                                    <div className="fw-bold">{plan.vRfc || '—'}</div>
                                    <div className="text-muted small">
                                        Plan de facturación: #{plan.idPlanFacturaMx}
                                    </div>
                                </div>
                                <SoftBadge bg={planActivo ? 'success' : 'danger'} className="ms-2">
                                    {planActivo ? 'Activo' : 'Inactivo'}
                                </SoftBadge>
                            </div>
                            <div className="d-flex align-items-center gap-1">
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={() => handleAbrirModalHistorial(plan)}
                                    style={{ fontSize: '0.72rem', padding: '2px 8px' }}
                                >
                                    Historial
                                </Button>
                                {puedeAsignarTimbresIniciales && esPlanActivo(plan) && esPlanNuevoSinTimbres(plan) && (
                                    <Button
                                        variant="outline-success"
                                        size="sm"
                                        onClick={() => handleAbrirModalTimbresIniciales(plan)}
                                        style={{ fontSize: '0.72rem', padding: '2px 8px' }}
                                    >
                                        Timbres iniciales
                                    </Button>
                                )}
                                <Button
                                    variant="link"
                                    size="sm"
                                    className="p-1 text-muted"
                                    onClick={() => handleEditarPlan(plan)}
                                    title="Editar RFC"
                                >
                                    <FontAwesomeIcon icon={faEdit} />
                                </Button>
                            </div>
                        </div>

                        {/* Fila de timbres */}
                        <div className="d-flex align-items-center justify-content-between px-3 py-2 border-top" style={{ background: planActivo ? '#f0fdf4' : '#f8f9fa' }}>
                            <div className="d-flex align-items-center gap-2">
                                <FontAwesomeIcon icon={faStamp} className="text-success" />
                                <span className="text-success fw-semibold small">Timbres disponibles</span>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <span className="fw-bold">{plan.iCantidades ?? 0}</span>
                                <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => handleAbrirModalAgregarTimbres(plan)}
                                    disabled={!planActivo}
                                    style={{ fontSize: '0.72rem', padding: '2px 8px' }}
                                >
                                    Agregar Timbres
                                </Button>
                                <Button
                                    variant={planActivo ? 'outline-danger' : 'outline-success'}
                                    size="sm"
                                    onClick={() => planActivo ? handleAbrirModalDesactivar(plan) : handleReactivarPlan(plan)}
                                    title={planActivo ? 'Desactivar RFC' : 'Reactivar RFC'}
                                    disabled={desactivando}
                                    style={{ fontSize: '0.72rem', padding: '2px 7px' }}
                                >
                                    <FontAwesomeIcon icon={planActivo ? faTrashAlt : faCheckCircle} />
                                </Button>
                            </div>
                        </div>

                    </div>
                        );
                    })()
                ))}
            </div>
        );
    };

    return (
        <>
            <Card className="mt-3 bordered">
                <Card.Header className="border-bottom border-200">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="mb-0">Planes de facturación Mx</h5>
                        {tabActivo === 'planes' && (
                            <div className="d-flex gap-2">
                                <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => handleAbrirModalAgregarTimbres(null)}
                                >
                                    Agregar Timbres
                                </Button>
                                <Button
                                    variant="primary"
                                    size="sm"
                                    onClick={handleAbrirModalAgregarPlan}
                                    disabled={cargando}
                                >
                                    Agregar Plan de Facturación
                                </Button>
                            </div>
                        )}

                    </div>
                    <Nav variant="tabs" activeKey={tabActivo} onSelect={(k) => setTabActivo(k)}>
                        <Nav.Item>
                            <Nav.Link eventKey="planes">Planes de Facturación</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="ordenes">Órdenes Planes de Facturación</Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Card.Header>
                <Card.Body style={{ maxHeight: '350px', overflowY: 'auto' }}>
                    {tabActivo === 'planes' ? renderContent() : renderOrdenesSinPlan()}
                </Card.Body>
            </Card>

            <Modal show={showModalAgregarPlan} centered onHide={handleCerrarModalAgregarPlan}>
                <Modal.Header closeButton>
                    <Modal.Title>{modoEdicion ? 'Editar Plan de Facturación' : 'Agregar Plan de Facturación'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>RFC</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Ingrese el RFC..."
                            value={rfcNuevoPlan}
                            onChange={(e) => setRfcNuevoPlan(e.target.value.toUpperCase())}
                            onKeyDown={(e) => { if (e.key === 'Enter' && rfcNuevoPlan.trim() && !guardandoPlan) handleGuardarNuevoPlan(); }}
                            maxLength={13}
                        />
                        <Form.Text className="text-muted">
                            Ingrese el RFC al que se asociará el plan de facturación
                        </Form.Text>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCerrarModalAgregarPlan}>
                        Cancelar
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleGuardarNuevoPlan}
                        disabled={guardandoPlan || !rfcNuevoPlan.trim()}
                    >
                        {guardandoPlan ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Guardando...
                            </>
                        ) : (
                            'Guardar'
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showModalTimbresIniciales} centered onHide={handleCerrarModalTimbresIniciales}>
                <Modal.Header closeButton>
                    <Modal.Title className="d-flex align-items-center justify-content-between gap-2">
                        <h5>Asignar Timbres Iniciales </h5>
                        <SoftBadge bg="success">
                            RFC: {planTimbresIniciales?.vRfc || '—'}
                        </SoftBadge>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    
                    <Form.Group>
                        <Form.Label>Cantidad de timbres</Form.Label>
                        <Form.Control
                            type="number"
                            min="1"
                            placeholder="Ej. 300"
                            value={cantidadTimbresIniciales}
                            onChange={(e) => setCantidadTimbresIniciales(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && cantidadTimbresIniciales && !guardandoTimbresIniciales) {
                                    handleGuardarTimbresIniciales();
                                }
                            }}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCerrarModalTimbresIniciales}>
                        Cancelar
                    </Button>
                    <Button
                        variant="success"
                        onClick={handleGuardarTimbresIniciales}
                        disabled={guardandoTimbresIniciales || !cantidadTimbresIniciales || parseInt(cantidadTimbresIniciales, 10) <= 0}
                    >
                        {guardandoTimbresIniciales ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Guardando...
                            </>
                        ) : (
                            'Asignar'
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showModalAgregarTimbres} centered onHide={handleCerrarModalAgregarTimbres} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{planSeleccionado ? 'Confirmar Orden' : 'Agregar Timbres'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {!planSeleccionado ? (
                        <>
                            <Form.Group className="mb-3">
                                <Form.Label>Buscar plan de facturación</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text>
                                        <FontAwesomeIcon icon={faSearch} />
                                    </InputGroup.Text>
                                    <Form.Control
                                        type="text"
                                        placeholder="Buscar por nombre o descripción..."
                                        value={busquedaPlan}
                                        onChange={(e) => setBusquedaPlan(e.target.value)}
                                    />
                                </InputGroup>
                            </Form.Group>

                            {cargandoPlanesDisponibles ? (
                                <div className="text-center py-4">
                                    <Spinner animation="border" />
                                    <p className="mt-2">Cargando planes disponibles...</p>
                                </div>
                            ) : planesFiltrados.length === 0 ? (
                                <div className="text-center py-4 text-muted">
                                    {busquedaPlan ? 'No se encontraron planes que coincidan con la búsqueda' : 'No hay planes disponibles'}
                                </div>
                            ) : (
                                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                    <Table hover responsive>
                                        <thead>
                                            <tr>
                                                <th>Producto</th>
                                                <th>Cantidad Timbres</th>
                                                <th>Precio</th>
                                                <th>Moneda</th>
                                                <th style={{ width: '120px' }}>Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {planesFiltrados.map((plan, index) => (
                                                <tr key={plan.vUUIDProducto || index}>
                                                    <td>{plan.vNombreProducto || 'N/A'}</td>
                                                    <td>{plan.iCantidadTimbresMx || 'N/A'}</td>
                                                    <td>{plan.dTotal ? '$' + plan.dTotal : 'N/A'}</td>
                                                    <td>{plan.vMoneda || 'N/A'}</td>
                                                    <td>
                                                        <Button
                                                            variant="success"
                                                            size="sm"
                                                            onClick={() => handleSeleccionarPlan(plan)}
                                                            className="w-100"
                                                        >
                                                            Seleccionar
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="mb-3 border rounded overflow-hidden">
                            <div className="bg-success bg-opacity-10 px-3 py-2 border-bottom d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center gap-2">
                                    <FontAwesomeIcon icon={faCheckCircle} className="text-success" />
                                    <span className="fw-semibold text-success">Resumen de la orden</span>
                                </div>
                                <SoftBadge bg="secondary" className="d-flex align-items-center gap-1">
                                    <FontAwesomeIcon icon={faCreditCard} />
                                    {formaPagoSeleccionada ? formaPagoSeleccionada.vDescripcionFormaPago : 'Por definir'}
                                </SoftBadge>
                            </div>
                            <div className="p-3">
                                <div className="d-flex align-items-start gap-3 mb-3 pb-3 border-bottom">
                                    <div className="rounded bg-primary bg-opacity-10 p-2 d-flex align-items-center justify-content-center" style={{ minWidth: '40px', height: '40px' }}>
                                        <FontAwesomeIcon icon={faBox} className="text-primary" />
                                    </div>
                                    <div>
                                        <div className="text-muted small">Producto</div>
                                        <div className="fw-bold">{planSeleccionado.vNombreProducto}</div>
                                    </div>
                                </div>
                                <div className="row g-3">
                                    <div className="col-6">
                                        <div className="d-flex align-items-center gap-2">
                                            <FontAwesomeIcon icon={faStamp} className="text-info" />
                                            <div>
                                                <div className="text-muted small">Timbres incluidos</div>
                                                <div className="fw-bold fs-5 text-info">{planSeleccionado.iCantidadTimbresMx}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="d-flex align-items-center gap-2">
                                            <FontAwesomeIcon icon={faDollarSign} className="text-success" />
                                            <div>
                                                <div className="text-muted small">Total a pagar</div>
                                                <div className="fw-bold fs-5 text-success">${planSeleccionado.dTotal} <span className="fs-3">{planSeleccionado.vMoneda}</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    {!planSeleccionado ? (
                        <Button variant="secondary" onClick={handleCerrarModalAgregarTimbres}>
                            Cancelar
                        </Button>
                    ) : (
                        <>
                            <Button variant="secondary" onClick={handleVolverALista}>
                                Volver
                            </Button>
                            <Button
                                variant="primary"
                                onClick={handleConfirmarOrden}
                                disabled={creandoOrden || !formaPagoSeleccionada}
                            >
                                {creandoOrden ? (
                                    <>
                                        <Spinner animation="border" size="sm" className="me-2" />
                                        Procesando...
                                    </>
                                ) : (
                                    'Confirmar Orden'
                                )}
                            </Button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>

            <ModalAsociarPlanFacturacion
                show={showModalAsociarPlan}
                onHide={handleCerrarModalAsociarPlan}
                ordenSeleccionada={ordenSeleccionada}
                onPlanAsociado={handlePlanAsociado}
                idCliente={idCliente}
            />

            <ModalHistorialPlanFacturacionMx
                show={showModalHistorial}
                onHide={handleCerrarModalHistorial}
                idClienteAkasia={idCliente}
                plan={planHistorialSeleccionado}
            />

            <Modal show={showModalDesactivar} centered onHide={handleCerrarModalDesactivar}>
                <Modal.Header closeButton>
                    <Modal.Title>Desactivar RFC</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {planADesactivar && (
                        <>
                            <p>
                                ¿Estás seguro de que deseas desactivar el RFC{' '}
                                <strong>{planADesactivar.vRfc}</strong>{' '}
                                (Plan #{planADesactivar.idPlanFacturaMx})?
                            </p>
                            {(planADesactivar.iCantidades ?? 0) > 0 && (
                                <div className="alert alert-info">
                                    <FontAwesomeIcon icon={faStamp} className="me-2" />
                                    Este RFC tiene <strong>{planADesactivar.iCantidades}</strong> timbres disponibles.
                                    Podrás reactivarlo después cuando lo necesites.
                                </div>
                            )}
                            <p className="text-muted small mb-0">
                                El plan será marcado como inactivo y dejará de aparecer en la lista.
                            </p>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCerrarModalDesactivar}>
                        Cancelar
                    </Button>
                    <Button
                        variant="danger"
                        onClick={handleConfirmarDesactivar}
                        disabled={desactivando}
                    >
                        {desactivando ? (
                            <><Spinner animation="border" size="sm" className="me-2" />Desactivando...</>
                        ) : (
                            'Desactivar RFC'
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>

        </>
    );
};

PlanesFacturacionMx.propTypes = {
    idCliente: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onPlanAgregado: PropTypes.func
};

export default PlanesFacturacionMx;
